import { render, staticRenderFns } from "./AcessProfileUsersList.vue?vue&type=template&id=5de25d4d"
import script from "./AcessProfileUsersList.vue?vue&type=script&lang=js"
export * from "./AcessProfileUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports